var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoCarte(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.209,
    height: 76.9,
    viewBox: "0 0 81.209 76.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 81.209,
    height: 76.9,
    fill: "#f9c977",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2555",
    "data-name": "Groupe 2555",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_883",
    "data-name": "Trac\\xE9 883",
    d: "M81.152,75.455,67.983,35.948a1.1,1.1,0,0,0-1.04-.751H64.748l-1.1,2.195h2.5L78.59,74.7H41.7V71.951a2.809,2.809,0,0,1,2.806-2.806H61.526A5,5,0,0,0,66.27,62.56l-.688-2.069a5,5,0,0,0-4.746-3.42H30.373a2.807,2.807,0,0,1-2.705-3.557l.306-1.107a2.813,2.813,0,0,1,2.7-2.058l14.314.137h.011a1.058,1.058,0,0,0,.176-.035,1.085,1.085,0,0,0,1.216-.229L60.459,36.066a21.241,21.241,0,0,0,0-29.872,20.911,20.911,0,0,0-29.7,0,21.242,21.242,0,0,0,0,29.872L42.889,48.273l-12.21-.116a5.016,5.016,0,0,0-4.82,3.665l-.307,1.109a5,5,0,0,0,4.821,6.337H60.836A2.8,2.8,0,0,1,63.5,61.186l.689,2.069a2.808,2.808,0,0,1-2.662,3.7H44.508a5.006,5.006,0,0,0-5,5V74.7H2.62L15.057,37.392H27.436l-1.1-2.195H14.267a1.1,1.1,0,0,0-1.042.751L.056,75.455A1.1,1.1,0,0,0,1.1,76.9H80.112a1.1,1.1,0,0,0,1.04-1.444M32.313,7.738a18.714,18.714,0,0,1,26.589,0,19.04,19.04,0,0,1,0,26.777L45.608,47.893l-13.3-13.379a19.04,19.04,0,0,1,0-26.777",
    transform: "translate(0 0)",
    fill: "#f9c977",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_884",
    "data-name": "Trac\\xE9 884",
    d: "M52.383,20.157a9.943,9.943,0,1,0-2.911,7.031,9.942,9.942,0,0,0,2.911-7.031m-9.943,7.749a7.747,7.747,0,1,1,5.479-2.269,7.746,7.746,0,0,1-5.479,2.269",
    transform: "translate(3.166 0.995)",
    fill: "#f9c977",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoCarte);
export default __webpack_public_path__ + "static/media/picto-carte.0dd77ed72d711a0c5c3a7145004effad.svg";
export { ForwardRef as ReactComponent };